
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRulesEl } from "@common/src/utils/verify";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import BtnRadio from "@common/src/components/scope/btn-radio/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import BtnCheckGroup from "@common/src/components/scope/btn-check-group/index.vue";
import { InjectFunction } from "@common/src/utils/decorator";

const partsCategory = namespace("parts-category");
const parts = namespace("parts");
const base = namespace("base");

@InjectFunction("permit")
@Component({
  components: { GeneralVehicleSelect, BtnRadio, TextTips, BtnCheckGroup }
})
export default class partsEdit extends Vue {
  @partsCategory.Action getCategoryList;
  @parts.Action createParts;
  @parts.Action getPartsDetail;
  @parts.Action updateParts;
  @parts.Action getPartsBrandList;
  @parts.Action createBrand;
  @base.Action getDictionaryList;
  @parts.Action getPartsList;
  @partsCategory.Action getCategoryListFillAll;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    return [
      { name: t("parts.info"), path: "/setting/parts" },
      {
        name: this.$route.name === "partsAdd" ? t("setting.added-parts") : t("setting.editing-spare-parts")
      }
    ];
  }
  get isSystemSet() {
    return this.partsFormData.source === 1;
  }
  partsFormData: any = {
    partsName: "",
    partsType: "single",
    partsNumber: "",
    brandCode: "",
    categoryCode: "",
    purchasePrice: "",
    sellingPrice: "",
    specification: "",
    oemNumber: "",
    partsUnit: "",
    vehicleModelCodes: [],
    partsRuleType: 3, //1:单个零配件,2:零配件组,3:零配件分类
    barcode: "",
    status: 1,
    source: 0,
    sourceDesc: t("setting.manually-create"),
    groupCategoryList: [], // 前端用
    groupPartsList: []
  };

  defaultVehicleList: any[] = [];
  partsUnitList: any[] = []; // 数据字典-单位
  categoryList: any[] = []; // 零配件分类数据
  brandList: any = [];

  categoryCasProps: any = {
    label: "categoryName",
    value: "categoryCode"
  };
  brandListCopy: any[] = [];

  partsFormRules = {
    partsName: [{ required: true, message: t("setting.enter-name-parts"), trigger: "blur" }],
    categoryCode: [{ required: true, message: t("setting.select-parts-classification"), trigger: "change" }],
    purchasePrice: [
      {
        validator: this.checkPrice,
        trigger: "blur"
      }
    ],
    sellingPrice: [
      {
        validator: this.checkPrice,
        trigger: "blur"
      }
    ],
    groupCategoryList: [{ required: true, message: t("setting.select-parts-classification"), trigger: "change" }],
    groupPartsList: [{ required: true, message: t("setting.select-spare-parts"), trigger: "change" }]
  };
  get isAdd() {
    return this.$route.name === "partsAdd";
  }
  created() {
    this.init();
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  getBrandList(callback?) {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []);
      this.brandListCopy = data.data.list;
      callback && callback();
    });
  }
  handleValidate(prop, validate) {
    if (validate && (prop === "purchasePrice" || prop === "sellingPrice")) {
      this.partsFormData[prop] = Number(this.partsFormData[prop]).toFixed(2);
    }
  }
  brandSearchValue: string = ""; // 品牌搜索keyword
  handleSearchBrand(val) {
    if (val) {
      this.brandSearchValue = val;
      this.brandList = this.brandList.filter(item => {
        return item.brandName.includes(val);
      });
    } else {
      this.brandList = this.brandListCopy;
    }
  }
  async addNewBrand() {
    (this.$refs["brandSelect"] as any).blur();
    const data = await this.createBrand({ brandName: this.brandSearchValue });
    this.getBrandList(() => {
      this.$nextTick(() => {
        this.partsFormData.brandCode = data.data.brandCode;
      });
    });
  }
  // 新增和编辑的时候将车型code集合添加到form中
  // addSeriesCodeToForm() {
  //   if (this.selectVehicleList && this.selectVehicleList[0]) {
  //     this.customerFormData.vehicle.modelCode = this.selectVehicleList[0].lastValue;
  //   }
  // }
  vehicleDataFormat(data) {
    if (!data) return;
    return data.map(item => ({
      lastValue: item.modelCode,
      name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
      valueGroup: [item.brandCode, item.seriesName, item.modelCode]
    }));
  }
  submitForm() {
    (this.$refs["partsFormRef"] as any).validate(valid => {
      if (valid) {
        if (this.isAdd) {
          this.saveParts("add");
        } else {
          this.saveParts("edit");
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  async init() {
    const queryPartsName = this.$route.query.partsName;
    if (queryPartsName) {
      this.partsFormData.partsName = queryPartsName;
    }
    this.getDictionaryList("parts_unit").then(data => {
      this.partsUnitList = data;
    });
    this.getBrandList();
    await this.remoteMethodParts();

    if (!this.isAdd) {
      const { data: partsDetailData } = await this.getPartsDetail({
        partsCode: this.$route.params.id
      });
      if (partsDetailData.partsRuleType === 1) {
        partsDetailData.partsType = "single";
      } else {
        partsDetailData.partsType = "group";
        if (partsDetailData.partsRuleType === 2) {
          partsDetailData.partsRuleList.forEach(parts => {
            if (!this.partsList.some(listParts => parts.ruleCode === listParts.partsCode)) {
              this.partsList.push({
                partsCode: parts.ruleCode,
                partsNameDesc: parts.ruleName
              });
            }
          });
          partsDetailData.groupPartsList = partsDetailData.partsRuleList.map(item => item.ruleCode);
        } else {
          partsDetailData.groupCategoryList = partsDetailData.partsRuleList?.[0].ruleCode.split(",");
        }
      }
      this.partsFormData = partsDetailData;
      this.defaultVehicleList = this.vehicleDataFormat(partsDetailData.vehicleModels);
    }
    this.queryCategory();
  }
  async queryCategory() {
    const categoryList =
      this.partsFormData.partsType === "single" ? await this.getCategoryList() : await this.getCategoryListFillAll();
    this.categoryList = this.addLeafFlag(categoryList.data || []);
  }
  // 过滤空children
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  // 新增和编辑的时候将车型code集合添加到form中

  async saveParts(type) {
    if (this.partsFormData.partsType === "single") {
      this.partsFormData.partsRuleType = 1;
    }
    if (this.partsFormData.partsRuleType === 2) {
      this.partsFormData.partsRuleList = this.partsFormData.groupPartsList.map(code => {
        return {
          ruleCode: code
        };
      });
    } else if (this.partsFormData.partsRuleType === 3) {
      this.partsFormData.partsRuleList = [
        {
          ruleCode: this.partsFormData.groupCategoryList.join(",")
        }
      ];
    }
    if (this.partsFormData.categoryCode) {
      this.partsFormData.categoryCode =
        typeof this.partsFormData.categoryCode === "string"
          ? this.partsFormData.categoryCode
          : (this.partsFormData.categoryCode as []).slice(-1)[0];
    }
    if (type === "add") {
      await this.createParts(this.partsFormData);
      this.$message.success(t("base.create-success") as string);
      this.$router.push(`/setting/parts`);
    } else {
      this.updateParts(this.partsFormData).then(() => {
        this.$message.success(t("base.update-success") as any);
        this.$router.push(`/setting/parts`);
      });
    }
  }
  handlePartsTypeChange() {
    (this.$refs.partsFormRef as any).resetFields();
    this.partsFormData.groupPartsList = [];
    this.queryCategory();
  }
  typeOptionsData: any = [
    {
      label: t("v216_6.single-component"),
      value: "single"
    },
    {
      label: t("v216_6.spare-parts-group"),
      value: "group"
    }
  ];
  get curTypeLabel() {
    return this.typeOptionsData.find(item => item.value === this.partsFormData.partsType)?.label;
  }
  partsList: any = [];
  remoteMethodParts(val = "") {
    return this.getPartsList({
      searchKey: val,
      pageNum: 1,
      pageSize: 20,
      notOpadmin: "1"
    }).then(data => {
      this.partsList = data.data?.list || [];
    });
  }
}
